// createCustomElement.js

import { createApp } from "vue";
import vuetify from "@/plugins/vuetify"; // Adjust the path according to your project structure
import { createPinia } from "pinia";
import { toast } from "vue3-toastify";

export function createCustomElement(component) {
  console.log("createCustomElement");
  return class extends HTMLElement {
    connectedCallback() {
      try {
        console.log("connectedCallback");
        const app = createApp(component);
        const pinia = createPinia();

        console.log("app", app);

        app.use(vuetify);
        app.use(pinia);
        app.config.globalProperties.$toast = toast;

        // Mount the app on the custom element itself
        console.log("mounting app");
        app.mount(this);
      } catch (error) {
        console.error("error", error);
      }
    }

    disconnectedCallback() {
      // Optional: Clean up if necessary
    }
  };
}
